import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderTvRemoteShellComponent } from './order-tv-remote-shell.container';
import { StrapiPageShellComponent } from '@/shared/components/strapi-page/containers/strapi-page-shell/strapi-page-shell.component';
import { OrderTVRemoteRoutingModule } from './order-tv-remote-routing.module';
import { PlaceRemoteOrderShellComponent } from './place-remote-order-shell.container';

@NgModule({
  declarations: [OrderTvRemoteShellComponent, PlaceRemoteOrderShellComponent],
  imports: [CommonModule, OrderTVRemoteRoutingModule, StrapiPageShellComponent],
  exports: [OrderTvRemoteShellComponent, PlaceRemoteOrderShellComponent],
})
export class OrderTVRemoteModule {}
